import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';

export const useSearchAsHomePage = () => useFlag(FlagType.SearchAsHomePage);
